import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomPrice, GroupFixedPrice } from '@src/app/core/models/contribution.model';
import { IbGiftCardsContributionService } from '@src/app/features/pages/contribution/services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';

@Component({
    selector: 'ib-gift-cards-contribution-import',
    templateUrl: './ib-gift-cards-contribution-import.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule]
})
export class IbGiftCardsContributionImportComponent implements OnInit{
    groupFixedPrices: GroupFixedPrice[] = [];
    groupCustomFixedPrice: CustomPrice;
    customPriceSelected: string= '';
    customPriceSelectedDiscountCalculated: string;
    showCustomDiscount: boolean;
    @Input() form!: FormGroup;
    constructor (
        public contributionService: IbGiftCardsContributionService,
        private translateService: TranslateService
    ){
        this.groupFixedPrices = contributionService.availabilityDataResponse.groupFixedPrices;
        this.groupCustomFixedPrice = contributionService.availabilityDataResponse.groupCustomPrice;
    }
    ngOnInit () {
        //assign first value by default
        if (this.groupFixedPrices && this.groupFixedPrices.length > 0) {
            this.form.get('giftCardAmount').setValue(this.groupFixedPrices[0]);
        }
        
    }
    inputIsChanged = (event: Event) => {
        this.customPriceSelected = (event.target as HTMLInputElement).value;
        if((event.target as HTMLInputElement).value) {
            this.form.get('giftCardAmount').setValue(
                {
                    'amount': (event.target as HTMLInputElement).value,
                    'discount': null,
                    'campaignId': this.groupCustomFixedPrice.campaignId
                }
            );
            this.calculateCustomPriceDiscount();
        }else {
            this.form.get('giftCardAmount').setValue(
                this.groupFixedPrices[0]
            );
        }
        this.checkShowCustomDiscount();
    };
    calculateCustomPriceDiscount = () => {
        const numDecimals = this.contributionService.contributionDataResponse.currency.decimals;
        const priceCalculated = `${(Number(this.customPriceSelected) -(Number(this.customPriceSelected) * (this.groupCustomFixedPrice.percentage / 100))).toFixed(numDecimals)}`.replace('.', this.contributionService.contributionDataResponse.currency.decimalSeparator).replace(',', this.contributionService.contributionDataResponse.currency.decimalSeparator);
        this.customPriceSelectedDiscountCalculated = `${priceCalculated} ${this.contributionService.contributionDataResponse.currency.symbol}`;
    };

    get customPriceErrorTranslate () {
        const min = this.groupCustomFixedPrice.minAmount;
        const max = this.groupCustomFixedPrice.maxAmount;
        return this.contributionService.getInstantTranslate('GIFT_CARD_IMPORT_ERROR_BETWEEN_DYNAMIC_PRICE').replace('XXX', min.toString()).replace('YYYY', max.toString());
    }
    checkShowCustomDiscount = () => {
        const customPriceError = this.form.get('giftCardAmount').errors?.amountTooHigh || this.form.get('giftCardAmount').errors?.amountTooLow;
        this.showCustomDiscount = (this.customPriceSelected && this.contributionService.availabilityDataResponse.groupCustomPrice.percentage > 0) && (customPriceError === false || customPriceError === undefined);
    };
}